import { Button, Col, Divider, Row, message } from 'antd';
import { isEmpty } from 'lodash';
import { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { useFormContext } from '../../Context/DeclarationContext';
import { HOME_ROUTE } from '../Router/constant';
import './prevNextButtons.scss';

type PrevNextButtonsProps = {
  currentStep: number;
  showModal: boolean;
  onSaveAndEndForm: React.Dispatch<React.SetStateAction<boolean>>;
};

const PrevNextButtons: FC<PrevNextButtonsProps> = ({ currentStep, onSaveAndEndForm, showModal }) => {
  const { state, dispatch } = useFormContext();
  const [stepValidated, setStepValidated] = useState([] as number[]);

  const onChangeToSteps = async (value: number, strictMode: boolean = true) => {
    const currentstep = state.step ?? 0;
    let uniqueStepList = stepValidated.filter((value, index, self) => self.indexOf(value) === index);
    //Verificacion del los formularios de terceros.
    if (currentstep === 4 && state.thirdPartyInvolved?.thirdPartyInformationAvailable) {
      if (isEmpty(state.thirdPartyInvolved?.thirdPartyInvolvedInformation)) {
        message.error('Debe llenar y guardar el formulario de terceros.');
        return;
      }
    }

    if (currentstep > 0 && value < currentstep) {
      dispatch({
        type: 'UPDATE_STEP',
        payload: value,
      });
      return;
    } else {
      const { elementForm } = state;

      elementForm?.submit();

      try {
        await elementForm?.validateFields();
      } catch (e) {}
      const errors = elementForm?.getFieldsError().filter((e) => {
        return !isEmpty(e.errors);
      });

      if (elementForm) {
        if (value === currentstep + 1 && isEmpty(errors)) {
          setStepValidated([...stepValidated, currentstep]);

          dispatch({
            type: 'UPDATE_STEP',
            payload: value,
          });
          return;
        }
      }

      if (stepValidated.includes(value) && isEmpty(errors)) {
        dispatch({
          type: 'UPDATE_STEP',
          payload: value,
        });
        return;
      }

      if (strictMode && value < currentstep && stepValidated.includes(value)) {
        dispatch({
          type: 'UPDATE_STEP',
          payload: value,
        });
        return;
      }

      if (uniqueStepList.length <= 5 && isEmpty(errors)) {
        dispatch({
          type: 'UPDATE_STEP',
          payload: value,
        });
        return;
      }

      message.error('No puede avanzar a la siguiente sección sin completar la anterior');
    }
  };

  return (
    <div>
      <Divider />
      <Row gutter={[24, 24]} className="place">
        {currentStep === 0 && (
          <Col>
            <Link to={HOME_ROUTE} className="btn-prevNext">
              Cancelar
            </Link>
          </Col>
        )}

        {currentStep > 0 && (
          <Col>
            <Button
              type="default"
              className="btn-prevNext move"
              onClick={() => {
                const step = state.step ?? 0;
                if (step > 0) {
                  onChangeToSteps(step - 1);
                }
              }}
            >
              Atras
            </Button>
          </Col>
        )}

        {currentStep !== 5 && (
          <Col>
            <Button
              className="btn-prevNext move"
              onClick={() => {
                const step = state.step ?? 0;
                if (step < 5) {
                  onChangeToSteps(step + 1);
                }
              }}
            >
              Siguiente
            </Button>
          </Col>
        )}

        {currentStep === 5 && (
          <Col>
            <Button className="btn-prevNext move" onClick={() => onSaveAndEndForm(!showModal)}>
              Grabar y finalizar
            </Button>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default PrevNextButtons;
